export {
  default as CodesComponent,
  renderCodesComponent,
} from './CodesComponent';
export * from './config';
